module.exports = __webpack_public_path__ + "static/media/dash.17f637b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/xanthomonas_pimiento/curativa/dash.png
// module id = 2208
// module chunks = 3